import agiChatsSelectedIcon from "@/src/assets/images/dark/sidebar/selected/agi_chats.svg";
import agiChatsSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/agi_chats.svg";
import agiChatsUnselectedIcon from "@/src/assets/images/dark/sidebar/unselected/agi_chats.svg";
import agiChatsUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/agi_chats.svg";
import getStartedSelectedIcon from "@/src/assets/images/dark/sidebar/selected/get_started.svg";
import getStartedSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/get_started.svg";
import homeSelectedIcon from "@/src/assets/images/dark/sidebar/selected/home.svg";
import homeSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/home.svg";
import homeUnselectedIcon from "@/src/assets/images/dark/sidebar/unselected/home.svg";
import homeUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/home.svg";
import prospectSelectedIcon from "@/src/assets/images/dark/sidebar/selected/prospect.svg";
import prospectSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/prospect.svg";
import prospectUnselectedIcon from "@/src/assets/images/dark/sidebar/unselected/prospect.svg";
import prospectUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/prospect.svg";
import engageSelectedIcon from "@/src/assets/images/dark/sidebar/selected/engage.svg";
import engageSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/engage.svg";
import engageUnselectedIcon from "@/src/assets/images/dark/sidebar/unselected/engage.svg";
import engageUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/engage.svg";
import sequencesSelectedIcon from "@/src/assets/images/dark/sidebar/selected/sequences.svg";
import sequencesSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/sequences.svg";
import sequencesUnselectedIcon from "@/src/assets/images/dark/sidebar/unselected/sequences.svg";
import sequencesUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/sequences.svg";
import callSelectedIcon from "@/src/assets/images/dark/sidebar/selected/call.svg";
import callSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/call.svg";
import callUnselectedIcon from "@/src/assets/images/dark/sidebar/unselected/call.svg";
import callUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/call.svg";
import crmSelectedIcon from "@/src/assets/images/dark/sidebar/selected/crm.svg";
import crmSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/crm.svg";
import crmUnselectedIcon from "@/src/assets/images/dark/sidebar/unselected/crm.svg";
import crmUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/crm.svg";
import contactsSelectedIcon from "@/src/assets/images/dark/sidebar/selected/contacts.svg";
import contactsSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/contacts.svg";
import contactsUnselectedIcon from "@/src/assets/images/dark/sidebar/unselected/contacts.svg";
import contactsUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/contacts.svg";
import companiesSelectedIcon from "@/src/assets/images/dark/sidebar/selected/companies.svg";
import companiesSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/companies.svg";
import companiesUnselectedIcon from "@/src/assets/images/dark/sidebar/unselected/companies.svg";
import companiesUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/companies.svg";
import customerDarkSelected from "@/src/assets/images/dark/sidebar/selected/customer.svg";
import customerLightSelected from "@/src/assets/images/light/sidebar/selected/customer.svg";
import customerDarkUnselected from "@/src/assets/images/dark/sidebar/unselected/customer.svg";
import customerLightUnselected from "@/src/assets/images/light/sidebar/unselected/customer.svg";
import leadsSelectedIcon from "@/src/assets/images/dark/sidebar/selected/leads.svg";
import leadsSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/leads.svg";
import leadsUnselectedIcon from "@/src/assets/images/dark/sidebar/unselected/leads.svg";
import leadsUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/leads.svg";
import dealsSelectedIcon from "@/src/assets/images/dark/sidebar/selected/deals.svg";
import dealsSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/deals.svg";
import dealsUnselectedIcon from "@/src/assets/images/dark/sidebar/unselected/deals.svg";
import dealsUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/deals.svg";
import listsSelectedIcon from "@/src/assets/images/dark/sidebar/selected/lists.svg";
import listsSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/lists.svg";
import listsUnselectedIcon from "@/src/assets/images/dark/sidebar/unselected/lists.svg";
import listsUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/lists.svg";
import analyseSelectedIcon from "@/src/assets/images/dark/sidebar/selected/analyse.svg";
import analyseSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/analyse.svg";
import analyseUnselectedIcon from "@/src/assets/images/dark/sidebar/unselected/analyse.svg";
import analyseUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/analyse.svg";
import automateSelectedIcon from "@/src/assets/images/dark/sidebar/selected/automate.svg";
import automateSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/automate.svg";
import automateUnselectedIcon from "@/src/assets/images/dark/sidebar/unselected/automate.svg";
import automateUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/automate.svg";
import newTasksSelectedIcon from "@/src/assets/images/dark/selected/new_tasks.svg";
import newTasksSelectedLightIcon from "@/src/assets/images/light/selected/new_tasks.svg";
import newTasksUnselectedIcon from "@/src/assets/images/dark/unselected/new_tasks.svg";
import newTasksUnselectedLightIcon from "@/src/assets/images/light/unselected/new_tasks.svg";
import actionsSelectedIcon from "@/src/assets/images/dark/sidebar/selected/actions.svg";
import actionsSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/actions.svg";
import actionsUnselectedIcon from "@/src/assets/images/dark/sidebar/unselected/actions.svg";
import actionsUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/actions.svg";
import contentSelectedIcon from "@/src/assets/images/dark/sidebar/selected/content.svg";
import contentSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/content.svg";
import contentUnselectedIcon from "@/src/assets/images/dark/sidebar/unselected/content.svg";
import contentUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/content.svg";
import findLeadsSelectedIcon from "@/src/assets/images/dark/sidebar/selected/find_leads.svg";
import findLeadsSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/find_leads.svg";
import findLeadsUnselectedIcon from "@/src/assets/images/dark/sidebar/unselected/find_leads.svg";
import findLeadsUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/find_leads.svg";
import findCompaniesSelectedIcon from "@/src/assets/images/dark/sidebar/selected/find_companies.svg";
import findCompaniesSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/find_companies.svg";
import findCompaniesUnselectedIcon from "@/src/assets/images/dark/sidebar/unselected/find_companies.svg";
import findCompaniesUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/find_companies.svg";
import dataEnrichmentSelectedIcon from "@/src/assets/images/dark/sidebar/selected/data_enrichment.svg";
import dataEnrichmentSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/data_enrichment.svg";
import dataEnrichmentUnselectedIcon from "@/src/assets/images/dark/sidebar/unselected/data_enrichment.svg";
import dataEnrichmentUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/data_enrichment.svg";
import signalsSelectedIcon from "@/src/assets/images/dark/sidebar/selected/signals.svg";
import signalsSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/signals.svg";
import signalsUnselectedIcon from "@/src/assets/images/dark/sidebar/unselected/signals.svg";
import signalsUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/signals.svg";
import reportsUnselectedIcon from "@/src/assets/images/dark/sidebar/unselected/reports.svg";
import reportsUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/reports.svg";
import emailSelectedIcon from "@/src/assets/images/dark/sidebar/selected/email.svg";
import emailSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/email.svg";
import emailUnselectedIcon from "@/src/assets/images/dark/sidebar/unselected/email.svg";
import emailUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/email.svg";
import conversationalIntelligenceSelectedIcon from "@/src/assets/images/dark/selected/conversation_intelligence.svg";
import conversationalIntelligenceSelectedLightIcon from "@/src/assets/images/light/selected/conversation_intelligence.svg";
import conversationalIntelligenceUnselectedIcon from "@/src/assets/images/neutral/unselected/conversation_intelligence.svg";
import conversationalIntelligenceUnselectedLightIcon from "@/src/assets/images/neutral/unselected/conversation_intelligence.svg";
import agentBuilderSelectedIcon from "@/src/assets/images/dark/sidebar/selected/agent_builder.svg";
import agentBuilderSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/agent_builder.svg";
import agentBuilderUnselectedIcon from "@/src/assets/images/dark/sidebar/unselected/agent_builder.svg";
import agentBuilderUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/agent_builder.svg";
import meetingsSelectedIcon from "@/src/assets/images/dark/sidebar/selected/meetings.svg";
import meetingsSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/meetings.svg";
import meetingsUnselectedIcon from "@/src/assets/images/dark/sidebar/unselected/meetings.svg";
import meetingsUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/meetings.svg";
import libraryUnselectedIcon from "@/src/assets/images/dark/sidebar/unselected/library.svg";
import libraryUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/library.svg";
import librarySelectedIcon from "@/src/assets/images/dark/sidebar/selected/library.svg";
import librarySelectedLightIcon from "@/src/assets/images/light/sidebar/selected/library.svg";
import processDesignSelectedIcon from "@/src/assets/images/dark/sidebar/selected/process_design.svg";
import processDesignSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/process_design.svg";
import processDesignUnselectedIcon from "@/src/assets/images/dark/sidebar/unselected/process_design.svg";
import processDesignUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/process_design.svg";
import esignSelectedIcon from "@/src/assets/images/dark/sidebar/selected/esign.svg";
import esignSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/esign.svg";
import esignUnselectedIcon from "@/src/assets/images/dark/sidebar/unselected/esign.svg";
import esignUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/esign.svg";
import referIcon from "@/src/assets/images/dark/sidebar/neutral/refer_icon.svg";
import referLightIcon from "@/src/assets/images/light/sidebar/neutral/refer_icon.svg";
import addMemberIcon from "@/src/assets/images/dark/sidebar/neutral/add_member_icon.svg";
import addMemberLightIcon from "@/src/assets/images/light/sidebar/neutral/add_member_icon.svg";
import installMobileIcon from "@/src/assets/images/dark/sidebar/neutral/install_mobile_icon.svg";
import installMobileLightIcon from "@/src/assets/images/light/sidebar/neutral/install_mobile_icon.svg";
import marketingSelectedDarkIcon from "@/src/assets/images/dark/selected/marketing_selected_dark_icon.svg";
import marketingSelectedLightIcon from "@/src/assets/images/light/selected/marketing_selected_light_icon.svg";
import marketingUnselectedIcon from "@/src/assets/images/neutral/grey/marketing_unselected_icon.svg";
import ecommerceMarketingSelectedDarkIcon from "@/src/assets/images/dark/sidebar/selected/ecommerce_marketing.svg";
import ecommerceMarketingUnselectedDarkIcon from "@/src/assets/images/dark/sidebar/unselected/ecommerce_marketing.svg";
import ecommerceMarketingSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/ecommerce_marketing.svg";
import ecommerceMarketingUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/ecommerce_marketing.svg";
import campaignsSelectedDarkIcon from "@/src/assets/images/dark/selected/campaigns_selected_dark_icon.svg";
import campaignsSelectedLightIcon from "@/src/assets/images/dark/selected/campaigns_selected_light_icon.svg";
import campaignsUnselectedIcon from "@/src/assets/images/neutral/grey/campaigns_unselected_icon.svg";
import appStoreDarkIcon from "@/src/assets/images/dark/sidebar/neutral/app_store.svg";
import appStoreLightIcon from "@/src/assets/images/light/sidebar/neutral/app_store.svg";

import projectsSelectedDarkIcon from "@/src/assets/images/dark/sidebar/selected/projects.svg";
import projectsUnselectedDarkIcon from "@/src/assets/images/dark/sidebar/unselected/projects.svg";
import projectsSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/projects.svg";
import projectsUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/projects.svg";

import dashboardsSelectedDarkIcon from "@/src/assets/images/dark/sidebar/selected/dashboards.svg";
import dashboardsUnselectedDarkIcon from "@/src/assets/images/dark/sidebar/unselected/dashboards.svg";
import dashboardsSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/dashboards.svg";
import dashboardsUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/dashboards.svg";

import voiceAgentSelectedIcon from "@/src/assets/images/dark/selected/voice_agent_dark_icon.svg";
import voiceAgentSelectedLightIcon from "@/src/assets/images/light/selected/voice_agent_icon.svg";

import businessReceptionistDarkIcon from "@/src/assets/images/dark/selected/business_receptionist_dark_icon.svg";
import businessReceptionistLightIcon from "@/src/assets/images/light/selected/business_receptionist_icon.svg";

import formsSelectedDarkIcon from "@/src/assets/images/dark/sidebar/selected/forms.svg";
import formsUnselectedDarkIcon from "@/src/assets/images/dark/sidebar/unselected/forms.svg";
import formsSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/forms.svg";
import formsUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/forms.svg";

import aiQaSelectedDarkIcon from "@/src/assets/images/dark/sidebar/selected/ai-qa.svg";
import aiQaUnselectedDarkIcon from "@/src/assets/images/dark/sidebar/unselected/ai-qa.svg";
import aiQaSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/ai-qa.svg";
import aiQaUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/ai-qa.svg";

import meetingLinksSelectedDarkIcon from "@/src/assets/images/dark/sidebar/selected/meeting_links.svg";
import meetingLinksUnselectedDarkIcon from "@/src/assets/images/dark/sidebar/unselected/meeting_links.svg";
import meetingLinksSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/meeting_links.svg";
import meetingLinksUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/meeting_links.svg";

import meetingNotetakerSelectedDarkIcon from "@/src/assets/images/dark/sidebar/selected/meeting_notetaker.svg";
import meetingNotetakerUnselectedDarkIcon from "@/src/assets/images/dark/sidebar/unselected/meeting_notetaker.svg";
import meetingNotetakerSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/meeting_notetaker.svg";
import meetingNotetakerUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/meeting_notetaker.svg";

import meetingRouterSelectedDarkIcon from "@/src/assets/images/dark/sidebar/selected/meeting_router.svg";
import meetingRouterUnselectedDarkIcon from "@/src/assets/images/dark/sidebar/unselected/meeting_router.svg";
import meetingRouterSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/meeting_router.svg";
import meetingRouterUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/meeting_router.svg";

import coderSelectedDarkIcon from "@/src/assets/images/dark/sidebar/selected/coder.svg";
import coderUnselectedDarkIcon from "@/src/assets/images/dark/sidebar/unselected/coder.svg";
import coderSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/coder.svg";
import coderUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/coder.svg";

import mobileAppSelectedDarkIcon from "@/src/assets/images/dark/sidebar/selected/mobile_app.svg";
import mobileAppUnselectedDarkIcon from "@/src/assets/images/dark/sidebar/unselected/mobile_app.svg";
import mobileAppSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/mobile_app.svg";
import mobileAppUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/mobile_app.svg";

import landingPageSelectedDarkIcon from "@/src/assets/images/dark/sidebar/selected/landing_page.svg";
import landingPageUnselectedDarkIcon from "@/src/assets/images/dark/sidebar/unselected/landing_page.svg";
import landingPageSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/landing_page.svg";
import landingPageUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/landing_page.svg";

import game2dSelectedDarkIcon from "@/src/assets/images/dark/sidebar/selected/game_2d.svg";
import game2dUnselectedDarkIcon from "@/src/assets/images/dark/sidebar/unselected/game_2d.svg";
import game2dSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/game_2d.svg";
import game2dUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/game_2d.svg";

import game3dSelectedDarkIcon from "@/src/assets/images/dark/sidebar/selected/game_3d.svg";
import game3dUnselectedDarkIcon from "@/src/assets/images/dark/sidebar/unselected/game_3d.svg";
import game3dSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/game_3d.svg";
import game3dUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/game_3d.svg";

import vibeVideoSelectedDarkIcon from "@/src/assets/images/dark/sidebar/selected/vibe_video.svg";
import vibeVideoUnselectedDarkIcon from "@/src/assets/images/dark/sidebar/unselected/vibe_video.svg";
import vibeVideoSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/vibe_video.svg";
import vibeVideoUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/vibe_video.svg";

import developerCenterSelectedDarkIcon from "@/src/assets/images/dark/sidebar/selected/developer_center.svg";
import developerCenterUnselectedDarkIcon from "@/src/assets/images/dark/sidebar/unselected/developer_center.svg";
import developerCenterSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/developer_center.svg";
import developerCenterUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/developer_center.svg";

import digitalEmployeesSelectedDarkIcon from "@/src/assets/images/dark/sidebar/selected/digital_employees.svg";
import digitalEmployeesUnselectedDarkIcon from "@/src/assets/images/dark/sidebar/unselected/digital_employees.svg";
import digitalEmployeesSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/digital_employees.svg";
import digitalEmployeesUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/digital_employees.svg";

import inferenceRouterSelectedDarkIcon from "@/src/assets/images/dark/sidebar/selected/inference_router.svg";
import inferenceRouterUnselectedDarkIcon from "@/src/assets/images/dark/sidebar/unselected/inference_router.svg";
import inferenceRouterSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/inference_router.svg";
import inferenceRouterUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/inference_router.svg";
import liveAssistSelectedDarkIcon from "@/src/assets/images/dark/sidebar/selected/live_assist.svg";
import liveAssistUnselectedDarkIcon from "@/src/assets/images/dark/sidebar/unselected/live_assist.svg";
import liveAssistSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/live_assist.svg";
import liveAssistUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/live_assist.svg";

import codeReviewerSelectedDarkIcon from "@/src/assets/images/dark/sidebar/selected/code_reviewer.svg";
import codeReviewerUnselectedDarkIcon from "@/src/assets/images/dark/sidebar/unselected/code_reviewer.svg";
import codeReviewerSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/code_reviewer.svg";
import codeReviewerUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/code_reviewer.svg";

import invoicesSelectedIcon from "@/src/assets/images/dark/sidebar/selected/invoices.svg";
import invoicesSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/invoices.svg";
import invoicesUnselectedIcon from "@/src/assets/images/dark/sidebar/unselected/invoices.svg";
import invoicesUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/invoices.svg";

import productsSelectedIcon from "@/src/assets/images/dark/sidebar/selected/products.svg";
import productsSelectedLightIcon from "@/src/assets/images/light/sidebar/selected/products.svg";
import productsUnselectedIcon from "@/src/assets/images/dark/sidebar/unselected/products.svg";
import productsUnselectedLightIcon from "@/src/assets/images/light/sidebar/unselected/products.svg";

export default {
  campaignsSelectedDarkIcon,
  campaignsSelectedLightIcon,
  campaignsUnselectedIcon,
  marketingSelectedDarkIcon,
  marketingUnselectedIcon,
  ecommerceMarketingSelectedDarkIcon,
  ecommerceMarketingUnselectedDarkIcon,
  ecommerceMarketingSelectedLightIcon,
  ecommerceMarketingUnselectedLightIcon,
  libraryUnselectedIcon,
  libraryUnselectedLightIcon,
  librarySelectedIcon,
  librarySelectedLightIcon,
  agiChatsSelectedIcon,
  agiChatsSelectedLightIcon,
  agiChatsUnselectedIcon,
  agiChatsUnselectedLightIcon,
  getStartedSelectedIcon,
  getStartedSelectedLightIcon,
  homeSelectedIcon,
  homeSelectedLightIcon,
  homeUnselectedIcon,
  homeUnselectedLightIcon,
  prospectSelectedIcon,
  prospectSelectedLightIcon,
  prospectUnselectedIcon,
  prospectUnselectedLightIcon,
  engageSelectedIcon,
  engageSelectedLightIcon,
  engageUnselectedIcon,
  engageUnselectedLightIcon,
  sequencesSelectedIcon,
  sequencesSelectedLightIcon,
  sequencesUnselectedIcon,
  sequencesUnselectedLightIcon,
  callSelectedIcon,
  callSelectedLightIcon,
  callUnselectedIcon,
  callUnselectedLightIcon,
  crmSelectedIcon,
  crmSelectedLightIcon,
  crmUnselectedIcon,
  crmUnselectedLightIcon,
  contactsSelectedIcon,
  contactsSelectedLightIcon,
  contactsUnselectedIcon,
  contactsUnselectedLightIcon,
  companiesSelectedIcon,
  companiesSelectedLightIcon,
  companiesUnselectedIcon,
  companiesUnselectedLightIcon,
  customerDarkSelected,
  customerLightSelected,
  customerDarkUnselected,
  customerLightUnselected,
  leadsSelectedIcon,
  leadsSelectedLightIcon,
  leadsUnselectedIcon,
  leadsUnselectedLightIcon,
  dealsSelectedIcon,
  dealsSelectedLightIcon,
  dealsUnselectedIcon,
  dealsUnselectedLightIcon,
  listsSelectedIcon,
  listsSelectedLightIcon,
  listsUnselectedIcon,
  listsUnselectedLightIcon,
  analyseSelectedIcon,
  analyseSelectedLightIcon,
  analyseUnselectedIcon,
  analyseUnselectedLightIcon,
  automateSelectedIcon,
  automateSelectedLightIcon,
  automateUnselectedIcon,
  automateUnselectedLightIcon,
  newTasksSelectedIcon,
  newTasksSelectedLightIcon,
  actionsSelectedIcon,
  actionsSelectedLightIcon,
  actionsUnselectedIcon,
  actionsUnselectedLightIcon,
  contentSelectedIcon,
  contentSelectedLightIcon,
  contentUnselectedIcon,
  contentUnselectedLightIcon,
  findLeadsSelectedIcon,
  findLeadsSelectedLightIcon,
  findLeadsUnselectedIcon,
  findLeadsUnselectedLightIcon,
  findCompaniesSelectedIcon,
  findCompaniesSelectedLightIcon,
  findCompaniesUnselectedIcon,
  findCompaniesUnselectedLightIcon,
  dataEnrichmentSelectedIcon,
  dataEnrichmentSelectedLightIcon,
  dataEnrichmentUnselectedIcon,
  dataEnrichmentUnselectedLightIcon,
  signalsSelectedIcon,
  signalsSelectedLightIcon,
  signalsUnselectedIcon,
  signalsUnselectedLightIcon,
  reportsUnselectedIcon,
  reportsUnselectedLightIcon,
  emailSelectedIcon,
  emailSelectedLightIcon,
  emailUnselectedIcon,
  emailUnselectedLightIcon,
  conversationalIntelligenceSelectedIcon,
  conversationalIntelligenceSelectedLightIcon,
  conversationalIntelligenceUnselectedIcon,
  conversationalIntelligenceUnselectedLightIcon,
  agentBuilderSelectedIcon,
  agentBuilderSelectedLightIcon,
  agentBuilderUnselectedIcon,
  agentBuilderUnselectedLightIcon,
  meetingsSelectedIcon,
  meetingsSelectedLightIcon,
  meetingsUnselectedIcon,
  meetingsUnselectedLightIcon,
  processDesignSelectedIcon,
  processDesignSelectedLightIcon,
  processDesignUnselectedIcon,
  processDesignUnselectedLightIcon,
  esignSelectedIcon,
  esignSelectedLightIcon,
  esignUnselectedIcon,
  esignUnselectedLightIcon,
  referIcon,
  referLightIcon,
  addMemberIcon,
  addMemberLightIcon,
  installMobileIcon,
  installMobileLightIcon,
  appStoreDarkIcon,
  appStoreLightIcon,
  voiceAgentSelectedIcon,
  voiceAgentSelectedLightIcon,
  businessReceptionistDarkIcon,
  businessReceptionistLightIcon,
  invoicesSelectedIcon,
  invoicesSelectedLightIcon,
  invoicesUnselectedIcon,
  invoicesUnselectedLightIcon,
  productsSelectedIcon,
  productsSelectedLightIcon,
  productsUnselectedIcon,
  productsUnselectedLightIcon,
  dark: {
    selected: {
      projects: projectsSelectedDarkIcon,
      dashboards: dashboardsSelectedDarkIcon,
      forms: formsSelectedDarkIcon,
        aiQa: aiQaSelectedDarkIcon,
        meetingLinks: meetingLinksSelectedDarkIcon,
        meetingNoteTaker: meetingNotetakerSelectedDarkIcon,
        meetingRouter: meetingRouterSelectedDarkIcon,
        coder: coderSelectedDarkIcon,
        mobileApp: mobileAppSelectedDarkIcon,
        landingPage: landingPageSelectedDarkIcon,
        game2d: game2dSelectedDarkIcon,
        game3d: game3dSelectedDarkIcon,
        vibeVideo: vibeVideoSelectedDarkIcon,
        developerCenter: developerCenterSelectedDarkIcon,
        digitalEmployees: digitalEmployeesSelectedDarkIcon,
        inferenceRouter: inferenceRouterSelectedDarkIcon,
        liveAssist: liveAssistSelectedDarkIcon,
        codeReviewer: codeReviewerSelectedDarkIcon,
    },
    unselected: {
      projects: projectsUnselectedDarkIcon,
      newTasksUnselectedIcon: newTasksUnselectedIcon,
      dashboards: dashboardsUnselectedDarkIcon,
      forms: formsUnselectedDarkIcon,
        aiQa: aiQaUnselectedDarkIcon,
        meetingLinks: meetingLinksUnselectedDarkIcon,
        meetingNoteTaker: meetingNotetakerUnselectedDarkIcon,
        meetingRouter: meetingRouterUnselectedDarkIcon,
        coder: coderUnselectedDarkIcon,
        mobileApp: mobileAppUnselectedDarkIcon,
        landingPage: landingPageUnselectedDarkIcon,
        game2d: game2dUnselectedDarkIcon,
        game3d: game3dUnselectedDarkIcon,
        vibeVideo: vibeVideoUnselectedDarkIcon,
        developerCenter: developerCenterUnselectedDarkIcon,
        digitalEmployees: digitalEmployeesUnselectedDarkIcon,
        inferenceRouter: inferenceRouterUnselectedDarkIcon,
        liveAssist: liveAssistUnselectedDarkIcon,
        codeReviewer: codeReviewerUnselectedDarkIcon,
    },
  },
  light: {
    selected: {
      projects: projectsSelectedLightIcon,
      marketingSelectedLightIcon: marketingSelectedLightIcon,
      dashboards: dashboardsSelectedLightIcon,
      forms: formsSelectedLightIcon,
        aiQa: aiQaSelectedLightIcon,
        meetingLinks: meetingLinksSelectedLightIcon,
        meetingNoteTaker: meetingNotetakerSelectedLightIcon,
        meetingRouter: meetingRouterSelectedLightIcon,
        coder: coderSelectedLightIcon,
        mobileApp: mobileAppSelectedLightIcon,
        landingPage: landingPageSelectedLightIcon,
        game2d: game2dSelectedLightIcon,
        game3d: game3dSelectedLightIcon,
        vibeVideo: vibeVideoSelectedLightIcon,
        developerCenter: developerCenterSelectedLightIcon,
        digitalEmployees: digitalEmployeesSelectedLightIcon,
        inferenceRouter: inferenceRouterSelectedLightIcon,
        liveAssist: liveAssistSelectedLightIcon,
        codeReviewer: codeReviewerSelectedLightIcon,
    },
    unselected: {
      projects: projectsUnselectedLightIcon,
      newTasksUnselectedLightIcon: newTasksUnselectedLightIcon,
      dashboards: dashboardsUnselectedLightIcon,
      forms: formsUnselectedLightIcon,
        aiQa: aiQaUnselectedLightIcon,
        meetingLinks: meetingLinksUnselectedLightIcon,
        meetingNoteTaker: meetingNotetakerUnselectedLightIcon,
        meetingRouter: meetingRouterUnselectedLightIcon,
        coder: coderUnselectedLightIcon,
        mobileApp: mobileAppUnselectedLightIcon,
        landingPage: landingPageUnselectedLightIcon,
        game2d: game2dUnselectedLightIcon,
        game3d: game3dUnselectedLightIcon,
        vibeVideo: vibeVideoUnselectedLightIcon,
        developerCenter: developerCenterUnselectedLightIcon,
        digitalEmployees: digitalEmployeesUnselectedLightIcon,
        inferenceRouter: inferenceRouterUnselectedLightIcon,
        liveAssist: liveAssistUnselectedLightIcon,
        codeReviewer: codeReviewerUnselectedLightIcon,
    },
  },
};
